<template>
  <div class="column q-pa-md">
    {{
      userDetail.nickname
    }}，如果在调研中有任何问题，都可以及时在这里反馈<br />我们会在第一时间与你联系。
    <q-input
      class="q-mt-lg"
      v-model="feedback"
      filled
      clearable
      autofocus
      dense
      color="blue-9"
      type="textarea"
    />

    <q-btn flat class="bg-blue-9 text-white q-mt-md" @click="submitContent">
      <q-icon name="fas fa-envelope-open-text q-mr-sm" size="13px" />
      <span>提交</span>
    </q-btn>
    <q-scroll-area style="height: 200px" class="q-mt-md">
      <q-expansion-item
        v-for="(f, index) in feedbackList"
        :key="index"
        icon="fas fa-comment-alt"
        label="点击查看详情"
        :caption="formatDate(f.timestamp.createdAt)"
        class="q-px-md"
      >
        {{ f.content }}
      </q-expansion-item>
    </q-scroll-area>
  </div>
</template>

<script>
import { date } from "quasar";
import { getFeedbackList } from "../../../api/endpoints/feedback/getFeedbackList";
import { createFeedback } from "../../../api/endpoints/feedback/createFeedback";
export default {
  data() {
    return {
      feedbackList: [],
      feedback: "",
    };
  },
  props: {
    userDetail: {
      type: Object,
      default: {},
    },
  },

  mounted() {
    this.getFeedbackList();
  },

  methods: {
    async submitContent() {
      // console.log("sub");
      await this.createFeedback(this.feedback);
      await this.getFeedbackList();
    },

    async getFeedbackList() {
      try {
        const response = await getFeedbackList();
        if (response.status || response.erroe) {
          console.log("response error", response);
          this.$q.notify({
            type: "danger",
            message: response.default || response.message,
          });
        } else {
          console.log("response", response);
          this.feedbackList = response;
        }
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: "出现了错误，获取反馈列表失败",
        });
      }
    },

    async createFeedback(feedback) {
      if (this.feedback === "") return;
      try {
        const response = await createFeedback({
          feedback_content: feedback,
          feedback_attachment_url: [],
        });
        if (response.status || response.erroe) {
          console.log("response error", response);
          this.$q.notify({
            type: "danger",
            message: response.default || response.message,
          });
        }
        this.$q.notify({
          type: "success",
          message: "反馈已提交，请耐心等待管理员的回复",
        });
        this.feedback = ""
      } catch (err) {
        console.log(err);
        this.$q.notify({
          type: "danger",
          message: `出现了错误，创建失败: ${err}`,
        });
      }
    },
    formatDate(datetime) {
      console.log(datetime);
      return date.formatDate(datetime, "YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>

<style>
</style>